module.exports = __webpack_public_path__ + "static/media/6. Gandhi.5918e82c.png";